// src/App.js
import './i18n';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ThemeProvider from './theme/ThemeProvider';

import HomePage from './pages/HomePage';
import ToolPage from './pages/ToolPage';
import ResultPage from './pages/ResultPage';
import ProfilePage from './pages/ProfilePage';
import HealthyFoods from './components/HealthyFoods';
import NearbyGyms from './components/NearbyGyms';
import NearbyHospitals from './components/NearbyHospitals';
import AboutPage from './pages/AboutPage';
import Legal from './pages/Legal';
import DownloadPage from './pages/DownloadPage';
import TermsOfService from './pages/TermsOfService';
import WellnessGuide from './pages/WellnessGuide';

import './App.css';
import ContactPage from './pages/ContactPage';

export default function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tool" element={<ToolPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/healthy-foods" element={<HealthyFoods />} />
          <Route path="/nearby-gyms" element={<NearbyGyms />} />
          <Route path="/nearby-hospitals" element={<NearbyHospitals />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/wellness-guide" element={<WellnessGuide />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
